export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.666 14.166H8.333v1.667h3.333v-1.667z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.166 4.166v11.667a3.333 3.333 0 003.333 3.333h5a3.333 3.333 0 003.334-3.333V4.166A3.333 3.333 0 0012.499.833h-5a3.333 3.333 0 00-3.333 3.333zM7.499 2.5h5c.92 0 1.667.746 1.667 1.666v11.667c0 .92-.746 1.667-1.667 1.667h-5c-.92 0-1.666-.747-1.666-1.667V4.166c0-.92.746-1.666 1.666-1.666z" />`,
  title: 'Smartphone',
  viewBox: '0 0 21 20',
};
